import { CompositeResponseError } from '@/shared/api/validation'

export const getFailedCreditNotesForInvoiceCancellationWarning = (err: unknown) => (
  (err instanceof CompositeResponseError ? err.failures : [])
    .filter(x => x.operation === 'revoke_credit_note_allocation')
    .map(x => x.context['creditNoteName'])
    .filter(x => typeof x === 'string')
)
